import * as Yup from 'yup'
import FormBuilder, { FormFields } from "app/modules/tp/builders/FormBuilder";
import { Service } from "../_models";
import * as ServiceAPI from "../_requests";
import { Client } from "../../clients/_models";
import ClientAPI from "../../clients/_requests";
import { generateFormFields as generateRideFormFields } from '../../rides/builders/RideFormBuilder';
import { Ride } from '../../rides/_models';

export const generateEntityForm = async () => {
    const response = await ClientAPI.getAllNoPagination({});
    let clients: Array<Client> = [];

    if (response?.success) {
        clients = response.data as Array<Client>;
    }

    const formFields: FormFields<Service> = {
        title0: {
            type: "titleView",
            title: "Info Generali",
            icon: <i className="fa-regular fa-calendar-days"></i>,
            columnNo: 0,
        },
        //id: {
        //    type: "text",
        //    key: "id",
        //    label: "# ID",
        //    attributes: {
        //        disabled: true
        //    },
        //    validation: Yup.number().integer().positive().nullable(),
        //    columnNo: 0,
        //},
        status: {
            type: "select",
            key: "status",
            label: "Stato Servizio",
            isMulti: false,
            options: [
                { label: 'Da effettuare', value: 'TO_START' },
                { label: 'In Corso', value: 'IN_PROGRESS' },
                { label: 'Terminato', value: 'FINISHED' },
                { label: 'Cancellato', value: 'CANCELED' }
            ],
            validation: Yup.mixed().required('Lo Stato del Servizio è obbligatorio'),
            columnNo: 0,
        },
        name: {
            type: "text",
            key: "title",
            label: "Titolo",
            validation: Yup.string()
                .max(256, 'Il Titolo deve essere di massimo 256 caratteri')
                .required('Il Titolo è obbligatorio'),
            columnNo: 0,
        },
        clients: {
            type: "select",
            key: "client",
            label: "Cliente",
            isMulti: false,
            options: clients.map((client: Client) => ({ value: (client.id?.toString()), label: `${client.displayed_name ?? ""} ${client.business_name ?? ""}` })),
            columnNo: 0,
        },
        client_referent: {
            type: "text",
            key: "client_referent",
            label: "Referente Cliente",
            validation: Yup.string()
                .max(50, 'Il Referente Cliente deve essere di massimo 50 caratteri')
                .nullable(),
            columnNo: 0,
        },
        client_referent_phone: {
            type: "text",
            key: "client_referent_phone",
            label: "Telefono del Referente Cliente",
            validation: Yup.string().nullable()
                .min(10, 'Il telefono deve avere almeno 10 caratteri')
                .max(11, 'Il telefono deve avere al massimo 11 caratteri')
                .matches(/^(\+)?[0-9]+$/, 'Il telefono deve essere valido'),
            columnNo: 0,
        },
        start_date: {
            type: "date_picker",
            key: "start_date",
            label: "Inizio Servizio",
            validation: Yup.array().of(Yup.object().shape({
                from: Yup.string().required('La Data Inizio Servizio è obbligatoria'),
                to: Yup.string().required('La Data Fine Servizio è obbligatoria'),
            })).nullable(),
            columnNo: 0,
        },
        end_date: {
            type: "date_picker",
            key: "end_date",
            label: "Fine Servizio",
            validation: Yup.array().of(Yup.object().shape({
                from: Yup.string().required('La Data Fine Servizio è obbligatoria'),
                to: Yup.string().required('La Data Fine Servizio è obbligatoria'),
            }))
                // .test('check-validity', "L'ora di arrivo deve essere maggiore dell'ora di inizio", (value) => (
                //     !!value?.every((item) =>  isTimeStateValid(item as TimeRangeState))
                // ))
                .nullable(),
            columnNo: 0,
        },
        duplicate: {
            showIf: async (s: Service) => s.id !== null,
            type: "buttonAction",
            key: "duplicate",
            attributes: {
                style: {
                    marginTop: "30px"
                }
            },
            confirmation: {
                title: "Genera fattura",
                description: "Sei sicuro di voler duplicare il servizio ? Assicurati di aver prima salvato le modifiche.",
            },
            label: "Duplica Servizio",
            action: async (s: Service) => {
                ServiceAPI.default.duplicate(s.id);
            },
            columnNo: 0,
        },
        title1: {
            type: "titleView",
            title: "Note interne",
            icon: <i className="fa-solid fa-clipboard"></i>,
            columnNo: 1,
        },
        notes: {
            type: "wysiwyg",
            key: "notes",
            validation: Yup.string().nullable()
                .max(500, 'Le note devono essere di massimo 500 caratteri'),
            columnNo: 1,
        },
        title2: {
            type: "titleView",
            title: "Preventivo",
            icon: <i className="fa-solid fa-calculator"></i>,
            columnNo: 2,
        },
        quotationFile: {
            type: "file_base64",
            key: "quotation_file",
            label: "Preventivo",
            columnNo: 2,
        },
        quotation: {
            type: "text",
            key: "quotation",
            label: "Numero Preventivo",
            validation: Yup.string()
                .max(50, 'Il Numero Preventivo deve essere di massimo 50 caratteri')
                .nullable(),
            columnNo: 2,
        },
        quotation_date: {
            type: "date_picker",
            key: "quotation_date",
            label: "Data Preventivo",
            validation: Yup.string().nullable(),
            columnNo: 2,
        },
        title3: {
            type: "titleView",
            title: "Prezzi",
            classes: "mt-7",
            icon: <i className="fa-solid fa-tag"></i>,
            columnNo: 2,
        },
        purchase_price: {
            type: "text",
            isCurrency: true,
            key: "purchase_price",
            label: "Prezzo di Acquisto (IVA esclusa)",
            validation: Yup
                .number()
                .positive("Il Prezzo deve essere maggiore di 0")
                .nullable()
                .typeError("Inserisci un Prezzo di Acquisto valido"),
            columnNo: 2,
        },
        selling_price: {
            type: "text",
            isCurrency: true,
            key: "selling_price",
            label: "Prezzo di Vendita (IVA esclusa)",
            validation: Yup
                .number()
                .positive("Il Prezzo deve essere maggiore di 0")
                .nullable()
                .typeError("Inserisci un Prezzo di Vendita valido"),
            columnNo: 2,
        },
        title4: {
            type: "titleView",
            title: "Fattura",
            icon: <i className="fa-solid fa-receipt"></i>,
            columnNo: 3,
        },
        invoice: {
            type: "buttonAction",
            key: "invoice",
            confirmation: {
                title: "Genera fattura",
                description: "Sei sicuro di voler generare la fattura?",
            },
            label: "Genera fattura",
            //showIf: async (s: Service) => s.id !== null,
            action: async (s: Service) => {
                ServiceAPI.sendInvoice(s.id);
            },
            columnNo: 3,
        },
    };
    return formFields;
};

const generateRelationTable = async () => {
    const formFields: FormFields<Service> = {
        rides: {
            type: "formbuilder",
            key: "rides",
            form: (await generateRideFormFields()),
            multiple: true,
            addLabel: "Aggiungi corsa",
            label: "Corsa",
        }
    };
    return formFields;
}

export type ServiceFormFieldsProps = {
    defaultActiveTab?: number;
}

export const ServiceFormBuilder = async (props?: ServiceFormFieldsProps) => {
    const associatedRidesForm: FormFields<Service> = await generateRelationTable();
    const entityForm: FormFields<Service> = await generateEntityForm();
    return FormBuilder<Service>({
        formFields:
        {
            hasTabs: true,
            defaultActiveTab: (props?.defaultActiveTab ?? 0),
            tabs: [
                {
                    name: "Servizio",
                    fields: entityForm
                },
                {
                    name: "Corse",
                    fields: associatedRidesForm
                },
            ]
        }
    });
};

export default ServiceFormBuilder;
